import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';

interface FunnelData {
  stage: string;
  count: number;
  rate?: number;
}


interface EngagementFunnelChartProps {
  data: FunnelData[];
  title: string;
  description: string;
  color?: string;
}

export function EngagementFunnelChart({
  data,
  title,
  description,
  color = '#8b5cf6'
}: EngagementFunnelChartProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={250}>
          <BarChart data={data} layout="horizontal">
            <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
            <XAxis
              type="number"
              className="text-xs"
              tick={{ fill: 'hsl(var(--muted-foreground))' }}
            />
            <YAxis
              type="category"
              dataKey="stage"
              className="text-xs"
              tick={{ fill: 'hsl(var(--muted-foreground))' }}
              width={100}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: 'hsl(var(--popover))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '8px',
              }}
              formatter={(value: number, name: string, props) => {
                const rate = (props.payload as FunnelData)?.rate;
                return [
                  <>
                    <div>{value.toLocaleString()} users</div>
                    {rate !== undefined && <div className="text-xs text-muted-foreground">{rate}% conversion</div>}
                  </>,
                  name
                ];
              }}
            />
            <Bar dataKey="count" name="Count" radius={[0, 8, 8, 0]}>
              {data.map((_entry, index) => (
                <Cell key={`cell-${index}`} fill={color} opacity={1 - (index * 0.2)} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
